<ng-template #loadingModal let-modal>
    <app-loader [loaderStyle]="{height: '100%'}"></app-loader>
</ng-template>

<ng-template #confirmModal let-modal>
    <div class="modal-header justify-content-center">
        <h3 class="fw-semibold">Xác nhận thông tin</h3>
        <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
            (click)="onClose()">
            <i class="ri-close-line"></i>
        </app-button>
    </div>
    <div class="p-3">
        <form [formGroup]="form" (ngSubmit)="onConfirm()">
            <div class="d-grid gap-2 pt-3">
                <h3 class="fw-bold">Thông tin cơ sở kinh doanh</h3>
                <div class="d-flex row">
                    <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="businessName1" required
                                formControlName="businessName" required />
                            <label for="businessName1">
                                Tên cơ sở kinh doanh
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label
                            *ngIf="form.controls['businessName'].touched && form.controls['businessName'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập tên cơ sở kinh doanh
                        </label>
                    </div>
                    <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="taxCode1" formControlName="taxCode" required />
                            <label for="taxCode1">
                                Mã số thuế
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label *ngIf="form.controls['taxCode'].touched && form.controls['taxCode'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Mã số thuế
                        </label>
                    </div>
                </div>
                <div class="d-flex row pb-2">
                    <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6">
                        <div class="form-floating">
                            <select2 class="form-control form-select select2-1" id="province"
                                aria-label="Default select example" formControlName="province"
                                (update)="loadWardsByProvince($event)" [value]="selectedProvince"
                                placeholder="Tỉnh/Thành phố *" [data]="select2Provinces">
                            </select2>
                            <label for="province">
                                Chọn Tỉnh/Thành phố
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label
                            *ngIf="form.controls['province'].touched && form.controls['province'].errors?.['required']"
                            class="invalid-feedback">
                            Chọn Tỉnh/Thành phố
                        </label>
                    </div>
                    <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6">
                        <div class="form-floating">
                            <select2 class="form-control form-select select2-1" id="ward"
                                aria-label="Default select example" formControlName="ward" placeholder="Phường Xã *"
                                [value]="selectedWard" [data]="select2Wards">
                            </select2>
                            <label for="ward">
                                Chọn Phường/Xã
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label *ngIf="form.controls['ward'].touched && form.controls['ward'].errors?.['required']"
                            class="invalid-feedback">
                            Chọn Phường/Xã
                        </label>
                    </div>
                </div>
                <div class="d-flex gap-1">
                    <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
                        <div class="form-floating">
                            <input type="email" class="form-control" id="address" formControlName="address" />
                            <label for="address">
                                Địa chỉ (số nhà, tên đường)
                            </label>
                        </div>
                    </div>
                </div>
                <div class="d-flex gap-1">
                    <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="buyerName" formControlName="buyerName" />
                            <label for="buyerName">
                                Họ tên người mua hàng
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label
                            *ngIf="form.controls['buyerName'].touched && form.controls['buyerName'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập họ tên người mua hàng
                        </label>
                    </div>
                </div>
            </div>
            <div class="d-grid gap-4 pt-3">
                <h3 class="fw-bold">Giấy phép đăng ký kinh doanh</h3>
                <div class="d-flex row">
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating h-100">
                            <input type="text" class="form-control h-100" id="businessLicensesNo1"
                                formControlName="businessLicensesNo" required />
                            <label for="businessLicensesNo1">
                                Số giấy phép
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label
                            *ngIf="form.controls['businessLicensesNo'].touched && form.controls['businessLicensesNo'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Số giấy phép
                        </label>
                    </div>
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating h-100">
                            <input class="form-control h-100" placeholder="Ngày cấp" name="dp1"
                                style="width: -webkit-fill-available;" id="businessLicensesDate1"
                                formControlName="businessLicensesDate" readonly ngbDatepicker #ds1="ngbDatepicker"
                                (click)="ds1.toggle()" required />
                            <label class="date-picker-label" for="businessLicensesDate1">
                                Ngày cấp
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label
                            *ngIf="form.controls['businessLicensesDate'].touched && form.controls['businessLicensesDate'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Ngày cấp
                        </label>
                    </div>
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating">
                            <textarea type="text" class="form-control" style="height: auto; resize: none;"
                                id="businessLicensesProvince1" formControlName="businessLicensesProvince"
                                rows="2"></textarea>
                            <label for="businessLicensesProvince1">
                                Nơi cấp
                                <span style="color: #dd0000">* </span>
                            </label>
                        </div>
                        <label
                            *ngIf="form.controls['businessLicensesProvince'].touched && form.controls['businessLicensesProvince'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Nơi cấp
                        </label>
                    </div>
                </div>
            </div>

            <div>
                <button type="submit" class="btn w-100 mt-3" style="background-color: var(--theme-color); color: #fff;"
                    [disabled]="form.invalid">
                    Xác nhận
                </button>
            </div>
        </form>
    </div>
</ng-template>